module.exports = __webpack_public_path__ + "img/menu6.75b5fbf5.png";